// ======================================================================
// File Name       : ImportAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as importListRequests from './httpRequests/importList';
import * as ActionTypes from '../constants/ActionTypes';

export function getEditListResult(data, pathOptions) {
  return dispatch =>
    importListRequests
      .postEditListGetResult(data, pathOptions)
      .then(response => dispatch(receiveEditListResult(response)));
}

export function importEditListFile(uploadFile, resultParam, pathOptions) {
  return dispatch =>
    importListRequests
      .postEditList({ uploadFile }, resultParam, pathOptions)
      .then(() => dispatch(getEditListResult(resultParam, pathOptions)));
}

function receiveEditListResult(result) {
  return {
    type: ActionTypes.IMPORT_LIST_RECEIVE_RESULT,
    result,
  };
}
